import { render, staticRenderFns } from "./GoodCommentList.vue?vue&type=template&id=7b92f926&"
import script from "./GoodCommentList.vue?vue&type=script&lang=js&"
export * from "./GoodCommentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports